import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_MEDIUM_SCREEN_850 } from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';
import SrHelpCard from 'client/components/SrHelpCard/SrHelpCard';
import SrGridRow from 'client/components/SrGridRow/SrGridRow';

const SrHelpCardSection = ({
  title,
  helpCards,
}) => {
  const isMediumScreen = useMediaQuery({
    query: MEDIA_QUERY_MEDIUM_SCREEN_850,
  });

  return (
    <SrBox width='100%'>
      <SrText
        weight='800'
        color='blueGreycliff'
        font='greycliff'
        size={isMediumScreen ? '28' : '40'}
        lineHeight={isMediumScreen ? '34px' : '45px'}
        align={isMediumScreen ? null : 'center'}
        display='block'
      >
        {title}
      </SrText>
      <SrFlex marginTop={isMediumScreen ? '18px' : '48px'} justify='center'>
        <SrGridRow
          width='100%'
          columns={isMediumScreen ? 2 : 3}
          columnGap={isMediumScreen ? '14px' : '24px'}
          rowGap={isMediumScreen ? '14px' : '24px'}
          columnWrapMobile={false}
        >
          {helpCards.map((helpCard) => (
            <SrHelpCard
              key={helpCard.title}
              title={helpCard.title}
              imageUrl={helpCard.imageUrl}
              linkUrl={helpCard.linkUrl}
            />
          ))}
        </SrGridRow>
      </SrFlex>
    </SrBox>
  );
};

SrHelpCardSection.propTypes = {
  title: PropTypes.string.isRequired,
  helpCards: PropTypes.array.isRequired,
};

SrHelpCardSection.displayName = 'SrHelpCardSection';

export default SrHelpCardSection;
